"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCancelBodyToJSON = exports.OrderCancelBodyFromJSONTyped = exports.OrderCancelBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function OrderCancelBodyFromJSON(json) {
    return OrderCancelBodyFromJSONTyped(json, false);
}
exports.OrderCancelBodyFromJSON = OrderCancelBodyFromJSON;
function OrderCancelBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cancellationReason': !(0, runtime_1.exists)(json, 'cancellationReason') ? undefined : json['cancellationReason'],
    };
}
exports.OrderCancelBodyFromJSONTyped = OrderCancelBodyFromJSONTyped;
function OrderCancelBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cancellationReason': value.cancellationReason,
    };
}
exports.OrderCancelBodyToJSON = OrderCancelBodyToJSON;
